<template>
  <div class="setting-field">
    <el-badge
        value="error"
        class="label"
        :hidden="!missing">
      <label> {{ label }} </label>
    </el-badge>
    <el-time-picker
        v-model="startTime"
        style="max-width: 40%"
        placeholder="Start time"
        size="medium"
        format="HH:mm A"
        :picker-options="{ format:'HH:mm A' }"
        :disabled="!isAdmin"
        @change="update(startTime)" />
    <span class="date-range__to-label">To</span>
    <el-time-picker
        v-model="endTime"
        style="max-width: 40%"
        placeholder="End time"
        size="medium"
        format="HH:mm A"
        :picker-options="{ format:'HH:mm A', minTime: startTime }"
        :disabled="!isAdmin"
        @change="update(endTime)" />
  </div>
</template>

<script>
import { set, every, isNumber, has, get } from "lodash";

const beginningOfDateInSeconds = (() => {
  let date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  return Math.round(date.getTime() / 1000);
})();
const timeToDate = (seconds) => {
  const milliseconds = (beginningOfDateInSeconds + seconds) * 1000;
  return new Date(milliseconds);
};

export default {
  name: "DateRange",
  props: {
    config: {
      type: Object,
      required: true,
      validator(object) {
        /*
        { label, path, value: { start_time, end_time }
        * */
        return (
          every(["label", "value", "path"], (k) => has(object, k)) &&
          isNumber(object.value.start_time) &&
          isNumber(object.value.end_time)
        );
      },
    },
  },
  data() {
    return {
      startTime: timeToDate(this.config.value.start_time),
      endTime: timeToDate(this.config.value.end_time),
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
    label() {
      return this.config.label;
    },
    path() {
      return this.config.path;
    },
    missing() {
      return get(this, "config.missing", false);
    },
    format() {
      return "HH:mm:ss A";
    },
  },
  methods: {
    update(timeType) {
      let dateRange = null;
      const seconds = (date) => Math.round(date.getTime() / 1000);
      const b = beginningOfDateInSeconds;
      if (timeType === "start") {
        dateRange = {
          start_time: seconds(this.startTime) - b,
          end_time: seconds(this.endTime) - b,
        };
      } else {
        dateRange = {
          start_time: seconds(this.startTime) - b,
          end_time: seconds(this.endTime) - b,
        };
      }
      const payload = set({}, this.path, dateRange);
      this.$emit("change", { payload, done: () => {} });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "settings";
@include settingField();
.date-range__to-label {
  margin: 0 7px !important;
}
</style>
